import { faStar } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

const ICON_SMALL = { width: 20, height: 20 };
const ICON_LARGE = { width: 28, height: 28 };

const ICON = <FontAwesomeIcon icon={faStar} />;

export default function Rating(theme: Theme): any {
  return {
    MuiRating: {
      defaultProps: { emptyIcon: ICON, icon: ICON },

      styleOverrides: {
        root: { "&.Mui-disabled": { opacity: 0.48 } },
        iconEmpty: { color: theme.palette.grey[500_48] },
        sizeSmall: { "& svg": { ...ICON_SMALL } },
        sizeLarge: { "& svg": { ...ICON_LARGE } },
      },
    },
  };
}
